import { Controller } from "react-hook-form";
import { Checkbox, FormControlLabel } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function HideWord({ methods, name }) {
  const { control } = methods;
  const { t } = useTranslation("exercise");

  return (
    <div className="flex gap-2 items-center">
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <FormControlLabel
            label={t("vocab.hide-word")}
            control={
              <Checkbox
                {...field}
                checked={field.value}
                onChange={(event) => {
                  field.onChange(event.target.checked);
                }}
                color="primary"
              />
            }
            labelPlacement="end"
            sx={{ margin: 0 }}
          />
        )}
      />
    </div>
  );
}
